import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken, removeToken } from "@/utils/auth";
import router from "../router";
import {
  tryHideFullScreenLoading,
} from "./loading-help";
import serviceConfig from "@/common/serviceConfig";

// 读取配置文件中的请求地址
const baseURL = serviceConfig.accountBaseUrl;
const service = axios.create({
  baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000, // 请求超时20秒
  // headers: {
  //   Token: getToken(),
  // },
});
// console.log("axios account 初始化完毕 token=", getToken());
let messageInstance = 0; // 只显示第一个错误，后面的拦截
let messageInstanceCount = 0;
service.interceptors.request.use(
  async (config) => {
    // const deviceID = await getDeviceId();
    // console.log("getDeviceId:", deviceID);
    // config.headers["Device-Id"] = deviceID;
    const token = getToken();
    if( token ){
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (!config.params) config.params = {};
    config.params.t = Math.random().toString(36).substring(2);
    messageInstanceCount++;
    return config;
  },
  (error) => {
    // console.log(error); // for debug
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    console.log(
      "🚀 ~ interceptors response:",
      response.data,
      response.request.responseURL,
    );
    tryHideFullScreenLoading();
    messageInstanceCount -= 1;

    // 1001: 没有找到用户
    // 1005: 用户token过期
    if (response.status === 200) {
      if (response.data.code === 1005 || response.data.code === 1001) {
        removeToken(); // 从 storage 的 cookie 中移除
        store.dispatch("user/removeToken"); // 从 redux 中移除
        router.push("/login");
      }
    }
    return response.data;
  },
  (error) => {
    console.log("🚀 ~ interceptors error:", error);
    // if (messageInstance) {
    //   messageInstance.close();
    // }
    // 隐藏loading
    tryHideFullScreenLoading();
    messageInstanceCount--;
    // 如果是登录，返回401后不刷新页面
    if (
      error.response &&
      error.response.status === 401 &&
      window.location.hash.indexOf("/login") === -1
    ) {
      store
        .dispatch("user/clearInfo")
        .then(() => {
          router.push("/login");
        })
        .catch(() => {
          router.push("/login");
        });
    }
    if (error && error.stack.indexOf("timeout") > -1 && messageInstance <= 0) {
      Message({
        message: "网络请求出错，请重试",
        type: "error",
        offset: 100,
      });
      messageInstance++;
    } else if (
      error.response &&
      error.response.status &&
      error.response.status === 500 &&
      window.location.hash.indexOf("/login") === -1 &&
      messageInstance <= 0
    ) {
      Message({
        message: error.response.data.msg || error,
        type: "error",
        offset: 100,
      });
      messageInstance++;
    } else {
      // Message({
      //   message: "服务器异常",
      //   type: "error",
      //   offset: 100,
      //   duration: 5 * 1000,
      // });
      // messageInstance++;
    }
    if (messageInstanceCount <= 0) {
      messageInstance = 0;
    }
    return Promise.reject(error);
  },
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/accountRequest.js